module.exports = __webpack_public_path__ + "static/media/Article4.87945e6d.webp";